export default "__VITE_ASSET__IkBUjDsC__"